import React from 'react';
import {
    Button, Col, Row, Breadcrumb, Input, Space, Table, Modal, Spin, Form,
    Typography, Divider, Popconfirm, Radio
} from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import Icon from '@ant-design/icons';
import {
    cardLayout,
    modaisDeConfig,
    colLisTabelaConfigs,
    modalAddModuloInputs
} from './GridStyle';

import { FaCogs } from 'react-icons/fa';
import InputAppChanges from '../../../../../components/InputAppChanges';
import PreVisualizacaoAlteracoes from '../components/PreVisualizacaoAlteracoes';
import useListVersaoApp from './useListVersaoApp';


const IconCogs = (props: any) => <Icon {...props} component={FaCogs} ></Icon>

const { Title } = Typography;

const ListVersaoApp: React.FC = () => {

    const {
        onClickVoltarConfigOfSystem,
        history,
        hasSelectedAdd,
        clickBotaoEditarDados,
        hasSelectedEdit,
        clickBotaoDeletarDados,
        loadingTable,
        onclickTable,
        rowSelection,
        columns,
        dadosTabelaState,
        modalAddConfigVisible,
        clickSubmitModalAddConfig,
        clickCancelModalAddConfig,
        loadingFormAdd,
        formRef,
        onChangeInputNumberNumero,
        onChangeInputNumberDiasParaAtualizar,
        onChangeInputNumberBuildIos,
        onChangeInputNumberBuildAndroid,
        handleChangeAlteracoes,
        alteracoes,
        valorNumero
    } = useListVersaoApp();

    return (
        <>
            <Row>
                <Col {...cardLayout}>
                    <Title level={3}><IconCogs style={{ fontSize: 35 }} /> Configurações do Sistema</Title>
                    <Breadcrumb>
                        <Breadcrumb.Item><a onClick={onClickVoltarConfigOfSystem}>Configurações do Sistema</a></Breadcrumb.Item>
                        <Breadcrumb.Item>Versão App</Breadcrumb.Item>
                    </Breadcrumb>
                    <Divider />
                </Col>
            </Row>
            <Row style={{ marginBottom: 16 }}>
                <Col>
                    <Button type="primary" className="botaoAdicionarAssociacao" disabled={!hasSelectedAdd} onClick={() => history.push("/configuracoesdosistema/salvarversaoapp")} >
                        Adicionar
                    </Button>

                </Col>
                <Col>
                    <Button type="primary" className="botaoEditarAssociacao" onClick={clickBotaoEditarDados} disabled={!hasSelectedEdit} >
                        Editar
                    </Button>
                    <Popconfirm
                        title="Deseja excluir?"
                        onConfirm={clickBotaoDeletarDados}
                        onCancel={() => { }}
                        okText="Sim"
                        cancelText="Não"
                    >
                        <Button className="botaoDeleteAssociacao" type="primary" danger
                            // disabled={!hasSelectedDel}
                            disabled={!hasSelectedEdit}
                        >
                            <DeleteOutlined />
                        </Button>
                    </Popconfirm>
                </Col>
            </Row>
            <Row>
                <Col {...colLisTabelaConfigs}>
                    <Table
                        loading={loadingTable}
                        rowKey={(record) => record.uuid}
                        onRow={(record, rowIndex) => {
                            return {
                                onClick: event => { onclickTable(record, rowIndex) }, // click row
                            };
                        }}
                        scroll={{ x: 850 }}
                        rowSelection={rowSelection}
                        columns={columns} dataSource={dadosTabelaState}
                        size="small"
                        pagination={{ locale: { items_per_page: '' } }}
                    />
                </Col>
            </Row>
            <Modal
                title="Adicionar Versão App"
                visible={modalAddConfigVisible}
                className="modalAddRotas"
                onOk={clickSubmitModalAddConfig}
                onCancel={clickCancelModalAddConfig}
                width={1200}
                footer={[
                    <Button key="back" disabled={loadingFormAdd} onClick={clickCancelModalAddConfig}>
                        Cancelar
                    </Button>,
                    <Button key="submit" type="primary" loading={loadingFormAdd} onClick={clickSubmitModalAddConfig}>
                        Salvar
                    </Button>,
                ]}
            >
                <Spin spinning={loadingFormAdd}>
                    <Form
                        ref={formRef}
                        name="formModalAddRotas"
                        layout="vertical"
                        initialValues={{
                            remember: true,
                        }}
                        onFinishFailed={() => { }}
                    >
                        <Row gutter={24}>
                            <Col span={16}>
                                <Row>
                                    <Col {...modalAddModuloInputs}>
                                        <Form.Item
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Preencha a Numero!",
                                                }
                                            ]}
                                            name="numero"
                                            label="Numero"
                                            style={{ margin: 5 }}
                                        >
                                            <Input
                                                onChange={onChangeInputNumberNumero}
                                                placeholder="Ex: 1.1" />
                                        </Form.Item>
                                    </Col>
                                    <Col {...modalAddModuloInputs}>
                                        <Form.Item
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Preencha a campo!",
                                                }
                                            ]}
                                            name="dias_para_atualizar"
                                            label="Dias para atualizar"
                                            style={{ margin: 5 }}
                                        >
                                            <Input
                                                onChange={onChangeInputNumberDiasParaAtualizar}
                                                placeholder="120"
                                                maxLength={3}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col {...modalAddModuloInputs}>
                                        <Form.Item
                                            rules={[
                                                {
                                                    required: false,
                                                    message: "Preencha o build ios!",
                                                }
                                            ]}
                                            name="build_ios"
                                            label="Build IOS"
                                            style={{ margin: 5 }}
                                        >
                                            <Input
                                                onChange={onChangeInputNumberBuildIos}
                                                placeholder="Ex: 1.1" />
                                        </Form.Item>
                                    </Col>
                                    <Col {...modalAddModuloInputs}>
                                        <Form.Item
                                            rules={[
                                                {
                                                    required: false,
                                                    message: "Preencha o build android!",
                                                }
                                            ]}
                                            name="build_android"
                                            label="Build Android"
                                            style={{ margin: 5 }}
                                        >
                                            <Input
                                                onChange={onChangeInputNumberBuildAndroid}
                                                placeholder="Ex: 1.1"
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col {...modalAddModuloInputs}>
                                        <Form.Item
                                            initialValue={true}
                                            name="force"
                                            label="Forçar atualizar o app"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Selecione o forçar!",
                                                }
                                            ]}
                                            style={{ marginTop: 5, marginBottom: 8 }}
                                        >
                                            <Radio.Group>
                                                <Radio.Button value={true}>Sim</Radio.Button>
                                                <Radio.Button value={false}>Não</Radio.Button>
                                            </Radio.Group>
                                        </Form.Item>
                                    </Col>
                                    {/* <Col {...modaisDeConfig}>
                                <Form.Item
                                    rules={[
                                        {
                                            required: false,
                                            message: "Por favor comente as alterações!",
                                        }
                                    ]}
                                    name="alteracoes"
                                    label="Alterações"
                                >
                                    <Input.TextArea style={{ maxHeight: 200, height: 100 }} />
                                </Form.Item>
                            </Col> */}
                                    <Col {...modaisDeConfig}>
                                        <Form.Item
                                            rules={[
                                                {
                                                    required: false,
                                                    message: "Por favor comente as alterações!",
                                                }
                                            ]}
                                            name="alteracoes_json"
                                            label="Alterações"
                                        >
                                            {/* <Input.TextArea style={{ maxHeight: 200, height: 100 }} /> */}
                                            <InputAppChanges onChange={handleChangeAlteracoes} value={alteracoes} name="alteracoes_json" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                            <Col>
                                {alteracoes && <PreVisualizacaoAlteracoes versao={valorNumero} alteracoes={alteracoes} />}
                            </Col>
                        </Row>
                    </Form>
                </Spin>
            </Modal>
        </>
    );
}

export default ListVersaoApp;
